import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UserChip from './UserChip';
import Wordmark from './Wordmark';

const NAV = [
  { section: 'Directory' },
  { label: 'Companies', path: '/platform' },
  { label: 'Invitation requests', path: '/platform/invitations' },
];

export default function PlatformSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const brandMark = <Wordmark className="logo-v3" />;

  const navBody = (
    <>
      <div
        className="ni admin-back"
        onClick={() => navigate('/home')}
        onKeyDown={(e) => e.key === 'Enter' && navigate('/home')}
        role="button"
        tabIndex={0}
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><path d="M9 11L5 7l4-4" /></svg>
        Back to programmes
      </div>
      {NAV.map((item, i) =>
        item.section ? (
          <div key={i} className="nav-section-lbl">{item.section}</div>
        ) : (
          <div
            key={item.path}
            className={`ni${location.pathname === item.path ? ' active' : ''}`}
            onClick={() => navigate(item.path)}
            onKeyDown={(e) => e.key === 'Enter' && navigate(item.path)}
            role="button"
            tabIndex={0}
          >
            {item.label}
          </div>
        )
      )}
    </>
  );

  if (collapsed) {
    return (
      <div className="sidebar" style={{ width: 48 }}>
        <div style={{ padding: '12px 0', borderBottom: '0.5px solid #d3d1c7', display: 'flex', justifyContent: 'center' }}>
          <button type="button" className="toggle-btn" style={{ width: 28, height: 28 }} onClick={() => setCollapsed(false)}>›</button>
        </div>
        <UserChip collapsed />
      </div>
    );
  }

  return (
    <div className="sidebar">
      <div className="sb-head">
        <div>
          {brandMark}
          <div className="logo-sub">Platform console</div>
        </div>
        <button type="button" className="toggle-btn" onClick={() => setCollapsed(true)} title="Collapse sidebar">‹</button>
      </div>

      <div className="nav-full" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
        {navBody}
      </div>

      <UserChip />
    </div>
  );
}
